module.exports = __webpack_public_path__ + "static/media/BAL-logo.b873063a.png";